<template>
  <div>
    <div>
      <a
        class="btn d-none d-xl-block btn-buyer-transparant btn-callback callBackAjaxModal"
        data-cy="btnCallback"
        @click="toggleModal"
      >
        Rappel gratuit
      </a>
      <a class="telephone display-mobile d-xl-none">
        <img :src="getPict('phone', 'svg', 'global')" :alt="'phone'" />
      </a>
    </div>
    <div
      ref="mail-modal"
      class="modal fade"
      :class="{ show, 'd-block': active }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Rappel gratuit</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="toggleModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group-callback form-group">
              <div class="row">
                <div class="col-md-4 col-12">
                  <img
                    :src="getPict('GestionHelp', 'svg', 'global')"
                    :alt="'Validé'"
                    class="ico-call-back"
                  />
                </div>
                <div class="col-md-8 col-12">
                  <div
                    v-if="display.success !== null"
                    class="text-success modal-callback-success"
                  >
                    <p class="success-message">
                      <img
                        :src="getPict('aloneValidate', 'svg', 'black')"
                        :alt="'Validé'"
                        width="30"
                        class="ico"
                      />
                      Votre demande a bien été prise en compte. <br />
                    </p>
                    <p class="success-message-inspector">
                      Un conseiller va vous contacter dans les plus brefs délais
                      !
                      <img
                        :src="getPict('satisfied', 'svg', 'global')"
                        :alt="'Validé'"
                        class="ico"
                      />
                    </p>
                  </div>
                  <div v-else class="row help-contact-block">
                    <div class="col-md-6 col-12">
                      <input-module
                        :type="'number'"
                        :name="'phone'"
                        :trads="tradPhone"
                        @update-value="setPhone"
                      />
                    </div>
                    <div class="col-md-6 col-12">
                      <p class="fake-label-text"></p>
                      <div class="btn-check-call text-center">
                        <button
                          type="button"
                          :next-loading="loading"
                          class="btn btn-secondary"
                          @click="callMeBack"
                        >
                          <span>Me rappeler</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-12 api-msg">
                      <span v-if="display.error !== null" class="text-danger">
                        {{ display.error }}</span
                      >
                      <span v-if="display.number !== null" class="text-danger">
                        Format incorrect (ex : 0601020304)</span
                      >
                    </div>
                    <div class="col-md-12 col-12">
                      <p v-if="display.error === null">
                        Vous pouvez également nous contacter au
                        <span class="titre-bold">{{ callNumber }}.</span>
                      </p>
                      <p class="hopening-hours">
                        <span class="titre-bold">Horraires d’ouverture :</span>
                        du lundi au vendredi de 9h à 19h et le samedi de 9h à
                        18h. Appel non surtaxé. Prix d’un appel local
                      </p>
                      <div class="col-sm-12 col-md-12 col-lg-12 cgv">
                        <a
                          target="_blank"
                          :href="validateUrl('/donnees-personnelles')"
                        >
                          Informations sur vos données personnelles
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import UtilMixin from "../../../mixins/UtilMixin";
import InputModule from "../../../components/modules/forms/InputModule";
import { sendGraphQLRequest } from "../../../utils/sendGraphQLRequest.js";

export default {
  name: "CallbackModalModule",
  components: {
    InputModule,
  },
  mixins: [UtilMixin],
  props: {
    type: {
      type: [Number, String],
      default: () => 1,
    },
  },
  data: () => ({
    route: "",
    subdomain: null,
    callNumber: null,
    phone: null,
    active: false,
    show: false,
    tradPhone: {
      label: "Téléphone",
      placeholder: "Ex : 0601020304",
      subLabel: "Permet de vous envoyer l'estimation sur votre mobile",
    },
    display: {
      error: null,
      number: null,
      success: null,
    },
    btnDisabled: false,
    loading: false,
    cdn: process.env.VUE_APP_CDN,
  }),
  mounted() {
    // Partnaire loading
    this.subdomain = this.getPartenaire().subdomain;
    this.partner = this.getPartenaire().subdomain;
    this.callNumber = this.getPartenaire().phoneNumber;
    this.route = this.getPartenaire().route;
  },
  methods: {
    setPhone(value) {
      this.phone = value;
    },
    toggleModal() {
      const body = document.querySelector("body");
      this.active = !this.active;
      this.active
        ? body.classList.add("modal-open")
        : body.classList.remove("modal-open");
      setTimeout(() => (this.show = !this.show), 10);
    },
    validateUrl(url) {
      return url + this.route;
    },
    async callMeBack() {
      const _this = this;
      const { sendRequest } = sendGraphQLRequest();
      this.display = {
        error: null,
        number: null,
        success: null,
      };
      if (!this.phone) {
        this.display.error = "Format incorrect (ex : 0601020304)";
        return;
      }
      const callMeBack = `mutation {
        addWebCallBack(type: ${this.type}, phone: "${this.phone}")
        {
          message
        }
      }
    `;
      if (this.phone.includes("08")) {
        this.display.number = "Format incorrect (ex : 0601020304)";
        return;
      }
      this.btnDisabled = false;
      this.loading = true;
      try {
        const resultat = await sendRequest(callMeBack);
        setTimeout(function () {
          if (resultat.data.addWebCallBack.message === "Appel en cours...") {
            _this.display.success = "Votre demande a bien été prise en compte.";
            _this.closeModal();
          } else {
            _this.display.error = `Oups, une erreur technique nous empêche de vous contacter. Merci de nous appeler au ${_this.callNumber}.`;
          }
        }, 1000);
      } catch (error) {
        console.error("Erreur GraphQL :", error);
      }
    },
    closeModal() {
      const _this = this;
      setTimeout(function () {
        _this.$refs["mail-modal"].hide();
      }, 3000);
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/sass/modules/modalCallBack";
</style>
